(function () {
    var typed = '';
    var TRIGGER = 'navidson';
    var closeBtn = null;
    var cleanup = [];
    var active = false;

    document.addEventListener('keypress', function (e) {
        typed += e.key.toLowerCase();
        if (typed.length > TRIGGER.length) typed = typed.slice(-TRIGGER.length);
        if (typed === TRIGGER) { typed = ''; startHoL(); }
    });

    if (decodeURIComponent(window.location.pathname).includes('/bücher/house-of-leaves')) {
        startHoL();
    }

    function startHoL() {
        if (active) return;
        active = true;

        blueHouse();

        var ghost = document.createElement('div');
        ghost.className = 'hol-ghost';
        ghost.textContent = 'THIS IS NOT FOR YOU';
        document.body.appendChild(ghost);
        cleanup.push(ghost);

        setTimeout(function () {
            var measure = document.createElement('div');
            measure.className = 'hol-measure';
            measure.innerHTML =
                'interior&nbsp;32 ft&nbsp;&nbsp;9.75 in<br>'
                + 'exterior&nbsp;32 ft&nbsp;&nbsp;4<span style="opacity:0">.00</span>&nbsp;&nbsp;in<br>'
                + '<span class="hol-measure-line">──────────────────</span><br>'
                + '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;5.75 in';
            document.body.appendChild(measure);
            cleanup.push(measure);
        }, 1800);

        closeBtn = document.createElement('button');
        closeBtn.className = 'ee-close';
        closeBtn.style.cssText = 'position:fixed;top:1rem;right:1.2rem;z-index:10001;';
        closeBtn.textContent = '×';
        closeBtn.addEventListener('click', stopHoL);
        document.body.appendChild(closeBtn);
    }

    function blueHouse() {
        var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null, false);
        var nodes = [];
        while (walker.nextNode()) {
            var n = walker.currentNode;
            var tag = n.parentNode && n.parentNode.tagName;
            if (tag && /^(SCRIPT|STYLE|BUTTON|TEXTAREA)$/.test(tag)) continue;
            if (n.parentNode && n.parentNode.classList && n.parentNode.classList.contains('hol-word')) continue;
            if (/house|haus/i.test(n.textContent)) nodes.push(n);
        }
        nodes.forEach(function (node) {
            var wrapper = document.createElement('span');
            wrapper.className = 'hol-blue-wrap';
            wrapper.innerHTML = escapeHtml(node.textContent).replace(/house|haus/gi, function (m) {
                return '<span class="hol-word">' + m + '</span>';
            });
            if (node.parentNode) node.parentNode.replaceChild(wrapper, node);
            cleanup.push(wrapper);
        });
    }

    function escapeHtml(str) {
        return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    function stopHoL() {
        active = false;
document.querySelectorAll('.hol-blue-wrap').forEach(function (el) {
            if (el.parentNode) {
                var text = document.createTextNode(el.textContent);
                el.parentNode.replaceChild(text, el);
            }
        });
        cleanup.forEach(function (el) { if (el.parentNode) el.remove(); });
        cleanup = [];
        if (closeBtn) { closeBtn.remove(); closeBtn = null; }
    }
})();
